import { Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { Switch } from '@/shared/ui/Switch';

type TPeriodProps = {
  yearlySelected: boolean;
  onToggle: (yearlySelected: boolean) => void;
};

export const BillingPeriodTabs = ({ yearlySelected, onToggle }: TPeriodProps) => {
  const handlePeriodChange = (_e: unknown, nextYearlySelected: boolean) => {
    onToggle(nextYearlySelected);
  };

  return (
    <Stack alignItems="center" flexDirection="row" gap={8} justifyContent="center">
      <Typography variant="body-2-md">
        Pay annual,{' '}
        <Typography color="primary.500" display="inline" variant="body-2-md">
          save up to 40%
        </Typography>
      </Typography>
      <Switch checked={yearlySelected} onChange={handlePeriodChange} />
    </Stack>
  );
};
